import {
  IAppState
} from './types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: IAppState = {
  initial: null,
  inProgress: true,
  isShow: false,
  isShowNotification: false,
  notificationMessage: "",
  requestsQty: 0,
  notificationRequestsQty: 0
}

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    showTransparentPreloaderAction: (state) => {
      state.isShow = true
      state.requestsQty = ++state.requestsQty
    },
    hideTransparentPreloaderAction: (state) => {
      state.requestsQty = --state.requestsQty
      if (!state.requestsQty) {
        state.isShow = false
      }
    },
    showNotificationAction: (state, action: PayloadAction<string>) => {
      state.isShowNotification = true
      state.notificationMessage = action.payload
      state.notificationRequestsQty = ++state.notificationRequestsQty
    },
    hideNotificationAction: (state) => {
      state.notificationRequestsQty = --state.notificationRequestsQty
      if (!state.notificationRequestsQty) {
        state.isShowNotification = false
      }
    }
  },
  extraReducers: (builder) => {
    //
  }
})

export const {
  showTransparentPreloaderAction, 
  hideTransparentPreloaderAction,
  showNotificationAction,
  hideNotificationAction

} = appSlice.actions

export default appSlice.reducer